import { render } from "./StudentCoursesRegistered.vue?vue&type=template&id=467a2cf0&scoped=true"
import script from "./StudentCoursesRegistered.vue?vue&type=script&lang=js"
export * from "./StudentCoursesRegistered.vue?vue&type=script&lang=js"

import "./student-courses-registered.css?vue&type=style&index=0&id=467a2cf0&scoped=true&lang=css&external"
import "./StudentCoursesRegistered.vue?vue&type=style&index=1&id=467a2cf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467a2cf0"]])

export default __exports__